<template>
    <div>
        <b-row class="mb-1" v-if="$mq == 'xl'">
            <div class="col pr-0" :style="`flex: 0 0 ${size}px !important`">
                <div class="text-right">
                    {{ titulo }}
                </div>
            </div>
            <div class="col">
                <div>
                    <strong><slot></slot></strong>
                </div>
            </div>
        </b-row>
        <b-row class="mb-1" v-if="$mq != 'xl'">
            <div class="col-12">
                <div>
                    {{ titulo }}
                </div>
            </div>
            <div class="col-12">
                <div>
                    <strong><slot></slot></strong>
                </div>
            </div>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        titulo: {
            type: String,
            default: ''
        },

        size: {
            type: String,
            default: '100'
        }
    },

    methods: {},

    computed: {}
}
</script>
